var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTransactionSourcei = function SvgTransactionSourcei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454B56",
    fillRule: "evenodd",
    d: "m14.66 14.133-6.244-.013c-.397.03-.707-.296-.705-.689a.683.683 0 0 1 .698-.691l7.977.003c.383.013.706.297.704.689a.77.77 0 0 1-.228.543l-2.65 2.528c-.282.275-.715.24-.989-.021a.743.743 0 0 1 .034-1.019zm-6.87-3.128a.69.69 0 0 1 .115-.838l2.586-2.505a.73.73 0 0 1 1.006-.02c.256.305.253.746-.03 1.02L10.082 10l6.317-.006a.72.72 0 0 1 .687.732c.015.35-.298.662-.694.692l-7.98-.005a.71.71 0 0 1-.621-.407m12.263 4.26a.7.7 0 0 1 .907-.357c.36.151.526.565.386.9-2.071 4.934-7.766 7.266-12.701 5.196-4.939-2.073-7.26-7.77-5.19-12.704C5.527 3.366 11.2 1.075 16.139 3.147a9.7 9.7 0 0 1 5.094 4.892c.154.36-.005.785-.353.934-.365.19-.771.02-.93-.341-.836-1.827-2.33-3.388-4.337-4.23-4.224-1.773-9.092.217-10.864 4.44s.217 9.093 4.441 10.865 9.092-.218 10.864-4.442",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTransactionSourcei);
export default ForwardRef;